import React, { useState } from "react";
import { FC } from "react";
import { FormField, TextInputField } from "../../../../components/Forms/fields";
import { Form } from "reactstrap";
import { useTranslations } from "../../../../store/translations/hooks";
import { TK } from "../../../../store/translations/translationKeys";
import { CheckInputField } from "../../../../components/Forms/fields/CheckInputField";
import AppButton from '../../../../components/AppButton';

export interface NewClientData {
    name?: string
    email?: string
    phone?: string
    notes?: string
    acceptConsents?: boolean
}

export const NewClientForm: FC<{
    data: NewClientData,
    invalidFields?: (keyof NewClientData)[],
    companyPolicyUrl?: string,
    onChange: (data: NewClientData) => void,
}> = ({
    data,
    invalidFields = [],
    companyPolicyUrl,
    onChange,
}) => {
    const t = useTranslations()

    return (<Form>
        <FormField label={`${t(TK.name)}*`}><TextInputField 
            id="client-name"
            value={data.name}
            invalid={invalidFields.includes('name')}
            onChange={v => onChange({...data, name: v?.trim().length ? v : undefined})}
        /></FormField>
        <FormField label={`${t(TK.email)}*`}><TextInputField 
            id="client-email"
            type="email"
            value={data.email}
            invalid={invalidFields.includes('email')}
            onChange={v => onChange({...data, email: v?.trim().length ? v : undefined})}
        /></FormField>
        <FormField label={`${t(TK.phoneNumber)}*`}><TextInputField 
            id="client-phone"
            type="tel"
            value={data.phone}
            invalid={invalidFields.includes('phone')}
            onChange={v => onChange({...data, phone: v?.trim().length ? v : undefined})}
        /></FormField>
        <FormField label={t(TK.observations)}><TextInputField 
            id="client-observations"
            type="textarea"
            value={data.notes}
            invalid={invalidFields.includes('notes')}
            onChange={v => onChange({...data, notes: v?.trim().length ? v : undefined})}
        /></FormField>
        <FormField 
            label={<>{t(TK.accept)} <a href={companyPolicyUrl} target="blank">{t(TK.privacyPolicy)}</a></>} 
            isCheckBox error={invalidFields.includes('acceptConsents') ? t(TK.mandatory) : undefined}
        >
            <CheckInputField 
                id={'company-policy'}
                invalid={invalidFields.includes('acceptConsents')}
                value={data.acceptConsents}
                onChange={acceptConsents => onChange({...data, acceptConsents})} 
            />
        </FormField>
    </Form>)
}